import React from "react";

const Epocrates = () => {
  return (
    <div className="card rounded-0 border-0 overflow-auto h-100 w-100 d-flex align-items-center justify-content-center">
      <iframe
        src={"https://www.epocrates.com/login?refernext=https%3A%2F%2Fwww.epocrates.com%2F&location=EOL"}
        title="Epocrates"
        width="100%"
        height="100%"
      />
    </div>
  );
};

export default Epocrates;
